import React from 'react';

import Thumb from '../img/power-x-gym.png';
import Img from '../img/power-x-gym2.png';

const PowerXGym = {
    id: 103, permalink: "power-x-gym", thumb: Thumb, title: "Power X Gym", category: "React", categoryURL: "react", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://w-power-x-gym.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Power X Gym is a Gym Website.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Google Web Fonts Included.</li>
            <li>Gym Classes Page</li>
            <li>Custom CSS Animation.</li>
            <li>Pricing Page, from this page user can go to payment option.</li>
            <li>Membership form developed using react form</li>
            <li>Integrated Stripe payment system</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>React, JavaScript, Sass, Node, MongoDB, Heroku, Firebase, Stripe, Google Analytics.</li>
        </ul>
    </>
};
export default PowerXGym;